import styles from "./styles.module.scss";

interface IUserInfo {
  name: string;
  isNationalIdVerified?: boolean;
  image?: string;
}

const UserInfo = ({ name, isNationalIdVerified, image }: IUserInfo) => {
  return (
    <div className={styles.container}>
      <div className={styles.image_container}>
        <img
          src={image || "/assets/images/user.png"}
          alt=""
          className={styles.image}
        />
        {isNationalIdVerified && (
          <img
            src="/assets/images/svg/verifiedIcon.svg"
            alt=""
            className={styles.id_verified_icon}
          />
        )}
      </div>
      <p className={styles.title}>{name}</p>
    </div>
  );
};

export default UserInfo;
